/**
 * @generated SignedSource<<36fcb0177c5a29d55d6ef7cb3e273815>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type McpSettings_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useClaudeMarketplace_query" | "useMCPEnabled_query">;
  readonly " $fragmentType": "McpSettings_query";
};
export type McpSettings_query$key = {
  readonly " $data"?: McpSettings_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"McpSettings_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "McpSettings_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useClaudeMarketplace_query"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useMCPEnabled_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "de896b91da50e7c5095308855cab6e18";

export default node;
